import type { IJSONSchema } from '../types';

export interface IScreen {
  id: string;
  screenableType?: ScreenableType;
  screenableId?: string;
  name: string;
  description: string;
  type: ScreenType;
  schema?: IJSONSchema;
  active?: boolean;
  version?: number;
  versionId?: string;
  status?: ScreenStatus;
}

export enum ScreenType {
  SinglePage = 'SINGLE_PAGE',
  ListPage = 'LIST_PAGE',
  CreatePage = 'CREATE_PAGE',
  Custom = 'CUSTOM',
}

export enum ScreenStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED',
}

export enum ScreenableType {
  Model = 'model',
}
